module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('timeline', {
    attrs: {
      "showGalleries": true
    }
  }), _vm._v("\n        " + _vm._s(_vm.weekChange) + "\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "panel intro-video-wrapper"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.localStorage.terms == '858356') ? _c('h2', [_vm._v("Intro Video")]) : _vm._e(), _vm._v(" "), (_vm.localStorage.terms != '858356' && _vm.noIntroVideo === false) ? _c('h2', [_vm._v("Week " + _vm._s(_vm.currentWeek + 1) + " Intro Video"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Your weekly introduction video from your supervisor and more!'),
      expression: "'Your weekly introduction video from your supervisor and more!'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.noIntroVideo === true) ? _c('img', {
    staticClass: "video-placeholder",
    attrs: {
      "src": require("../assets/img/video-placeholder.jpg")
    }
  }) : _c('poly-video', {
    class: {
      'hide-annotations': _vm.showAnnotations === false
    },
    attrs: {
      "sources": [_vm.introVideoUrl]
    }
  })], 1)]), _vm._v(" "), _c('next-live-session')], 1), _vm._v(" "), (_vm.noTerm) ? _c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('img', {
    staticClass: "mock-assignments",
    attrs: {
      "src": require("../assets/img/courses-placeholder.jpg")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.courses && _vm.assignmentsLoaded) ? _c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "panel course-widget-wrapper"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("My Courses"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Your courses including direct links to this week\'s videos, assignments and exercises.'),
      expression: "'Your courses including direct links to this week\\'s videos, assignments and exercises.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), (_vm.hasCourseSets && _vm.currentTerm.courseSets && _vm.currentTerm.courseSets.length > 0) ? _c('div', {
    staticClass: "course-set-switcher"
  }, [_c('ul', _vm._l((_vm.currentTerm.courseSets), function(set) {
    return _c('li', [_c('span', {
      class: {
        'selected': _vm.currentTerm.selectedCourseSet == set.id
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectCourseSet(set.id)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(set.name))])])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.currentTerm && new Date(_vm.currentTerm.startDate) <= new Date()) ? _c('ul', {
    staticClass: "list-group courses"
  }, _vm._l((_vm.courses), function(course) {
    return (course && course.associated && course.associated.latestVideo && course.associated.latestVideo.length > 0) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!course.associated.courseSets ||
          !_vm.currentTerm.selectedCourseSet ||
          course.associated.courseSets.length === 0 ||
          course.associated.courseSets.includes(_vm.currentTerm.selectedCourseSet)),
        expression: "\n                            !course.associated.courseSets\n                            || !currentTerm.selectedCourseSet\n                            || course.associated.courseSets.length === 0\n                            || course.associated.courseSets.includes(currentTerm.selectedCourseSet)"
      }],
      staticClass: "list-group-item row course-list"
    }, [_vm._v("\n                            " + _vm._s(_vm.selectedCourseSet) + "\n                            "), _vm._l((course.associated.latestVideo), function(video) {
      return (!video.lastWeekAvailable || (video.lastWeekAvailable && video.lastWeekAvailable >= (_vm.currentWeek + 1))) ? _c('div', {
        staticClass: "clearfix video"
      }, [_c('div', {
        staticClass: "col-xs-4 video-thumb-wrapper",
        class: {
          'faded': video.week !== _vm.currentWeek + 1
        }
      }, [_c('div', {
        staticClass: "video-thumbnail"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'videoPlayer',
            params: {
              courseId: course.associated.courseId,
              instanceId: course.id,
              videoId: video.id
            },
            query: {
              term: course.term,
              week: video.week
            }
          }
        }
      }, [(course.associated.image) ? _c('img', {
        staticClass: "course-image",
        attrs: {
          "src": course.associated.image
        }
      }) : _c('img', {
        staticClass: "course-image",
        attrs: {
          "src": require("../assets/img/ttto-thumbnail.png")
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "play-button",
        attrs: {
          "src": require("../assets/img/play-button.png")
        }
      })])], 1)]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-8 course-details",
        class: {
          'faded': video.week !== _vm.currentWeek + 1
        }
      }, [_c('div', {
        staticClass: "clearfix"
      }, [_c('h3', {
        staticClass: "course-name"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'course',
            params: {
              termId: course.term,
              courseId: course.associated.courseId,
              instanceId: course.id
            }
          }
        }
      }, [_vm._v("\n                                                " + _vm._s(course.associated.name) + "\n\n                                            ")])], 1), _vm._v(" "), (course.assignments &&
        course.assignments[0] &&
        course.associated.latestVideo &&
        _vm.assignmentThisWeek(course.assignments, video.week)) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'videoPlayer',
            params: {
              courseId: course.associated.courseId,
              instanceId: course.id,
              videoId: video.id
            },
            query: {
              term: course.term,
              week: video.week,
              tab: 'assignment'
            }
          }
        }
      }, [(!_vm.assignmentThisWeek(course.assignments, video.week).submission) ? _c('img', {
        staticClass: "icon",
        attrs: {
          "src": require("../assets/img/assignment-icon.png")
        }
      }) : _c('img', {
        staticClass: "icon",
        attrs: {
          "src": require("../assets/img/assignment-icon-grey.png")
        }
      })]) : _vm._e(), _vm._v(" "), (video.exercise) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'videoPlayer',
            params: {
              courseId: course.associated.courseId,
              instanceId: course.id,
              videoId: video.id
            },
            query: {
              term: course.term,
              week: video.week,
              tab: 'exercise'
            }
          }
        }
      }, [(video.exercise && !video.exercise.exercise_hand_ins.length > 0) ? _c('img', {
        staticClass: "icon",
        attrs: {
          "src": require("../assets/img/exercise-icon.png")
        }
      }) : _c('img', {
        staticClass: "icon",
        attrs: {
          "src": require("../assets/img/exercise-icon-grey.png")
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "video-progress col-xs-12 nopad"
      }, [_c('p', [_vm._v("Week " + _vm._s(video.week) + ":\n                                                "), _c('span', {
        staticClass: "percent-watched"
      }, [_vm._v("\n                                                    " + _vm._s(_vm.calculateProgress(video.progression, video.video_chapters)) + "% Watched")])]), _vm._v(" "), _c('div', {
        staticClass: "ttto-progress-wrapper"
      }, [_c('div', {
        staticClass: "ttto-progress",
        style: ({
          'width': _vm.calculateProgress(video.progression, video.video_chapters) + '%'
        })
      })])])], 1)])]) : _vm._e()
    }), _vm._v(" "), (course.associated.latestVideo[0].lastWeekAvailable && course.associated.latestVideo[0].lastWeekAvailable < (_vm.currentWeek + 1)) ? _c('div', {
      staticClass: "no-video"
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_vm._v("\n                                    No video this week\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'course',
          params: {
            termId: course.term,
            courseId: course.associated.courseId,
            instanceId: course.id
          }
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(course.associated.name) + "\n                                    ")])], 1)]) : _vm._e()], 2) : _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!course.associated.courseSets ||
          !_vm.currentTerm.selectedCourseSet ||
          course.associated.courseSets.length === 0 ||
          course.associated.courseSets.includes(_vm.currentTerm.selectedCourseSet)),
        expression: "\n                            !course.associated.courseSets\n                            || !currentTerm.selectedCourseSet\n                            || course.associated.courseSets.length === 0\n                            || course.associated.courseSets.includes(currentTerm.selectedCourseSet)"
      }],
      staticClass: "no-video list-group-item row course-list"
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_vm._v("\n                                No video this week\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'course',
          params: {
            termId: course.term,
            courseId: course.associated.courseId,
            instanceId: course.id
          }
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(course.associated.name) + "\n                                ")])], 1)])
  })) : _c('img', {
    attrs: {
      "src": require("../assets/img/courses-placeholder.jpg")
    }
  })])])]) : _vm._e()]), _vm._v(" "), (_vm.currentTerm) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading assignments"
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/img/assignment-icon.png")
    }
  }), _vm._v("Assignments"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('A sortable assignment table including due dates, marks and recorded feedback.'),
      expression: "'A sortable assignment table including due dates, marks and recorded feedback.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), (_vm.hasCourseSets && _vm.currentTerm.courseSets && _vm.currentTerm.courseSets.length > 0) ? _c('div', {
    staticClass: "course-set-switcher"
  }, [_c('ul', _vm._l((_vm.currentTerm.courseSets), function(set) {
    return _c('li', [_c('span', {
      class: {
        'selected': _vm.currentTerm.selectedCourseSet == set.id
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectCourseSet(set.id)
        }
      }
    }, [_vm._v("\n\n                                    " + _vm._s(set.name) + "\n                                ")])])
  }))]) : _vm._e()]), _vm._v(" "), (_vm.noTerm) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('img', {
    staticClass: "mock-assignments",
    attrs: {
      "src": require("../assets/img/assignments-placeholder.jpg")
    }
  })]) : _c('div', {
    staticClass: "panel-body"
  }, [(_vm.assignmentsLoaded === true &&
    _vm.courses &&
    _vm.courses.length > 0 &&
    _vm.currentTerm && new Date(_vm.currentTerm.startDate) <= new Date()) ? _c('div', {
    staticClass: "assignments"
  }, [_c('assignments-table', {
    attrs: {
      "currentWeek": _vm.currentWeek
    }
  })], 1) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row col-xs-12"
  }, [_c('latest-posts')], 1), _vm._v(" "), (_vm.showOverlay) ? _c('div', {
    staticClass: "overlay"
  }, [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Thank you for choosing your path for next term."), _c('br'), _vm._v("\n            If you have any questions, please create an admissions ticket."), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-926fa0ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 2104
// module chunks = 2